import React from 'react'
import FeatureFilter46 from './46/FeatureFilter'
import FeatureFilter56 from './56/FeatureFilter'
import FeatureFilter57 from './57/FeatureFilter'
import FeatureFilter58 from './58/FeatureFilter'
import FeatureFilter62 from './62/FeatureFilter'

const FeatureFilter = (props) => {

  return (
    <>
      {parseInt(process.env.REACT_APP_PROJECTID) === 46 ? <FeatureFilter46 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 56 ? <FeatureFilter56 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 57 ? <FeatureFilter57 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 58 ? <FeatureFilter58 {...props}/> : null }
      {parseInt(process.env.REACT_APP_PROJECTID) === 62 ? <FeatureFilter62 {...props}/> : null }
    </>
  )
}
export default FeatureFilter
